import React from 'react';
import cls from 'classnames';

import { Box } from 'wui/Box';

import { Column } from './Column';

import styles from './Layout.scss';

type ColumnType = React.ReactElement<React.ComponentProps<typeof Column>>;

interface IProps extends React.ComponentProps<typeof Box> {
  children: ColumnType | ColumnType[];
}

export function Layout(props: IProps) {
  const { children, className, ...rest } = props;

  const multiple = React.Children.count(children) > 1;

  const columns = !multiple
    ? children
    : React.Children.map(children, (child, index) =>
        React.cloneElement(child, {
          ...child.props,
          className: cls(
            child.props.className,
            index === 0 ? styles.main : styles.info,
          ),
        }),
      );

  return (
    <Box
      direction={multiple ? 'horizontal' : 'vertical'}
      className={cls(styles.root, className, {
        [styles.multiple]: multiple,
      })}
      {...rest}
    >
      {columns}
    </Box>
  );
}

Layout.displayName = 'Layout';
